import axios from 'axios';
import config from '../config';
import router from '../router';
import storage from '../uitls/cacheUtil';

export * from './NetworkAPI';

const contentType = 'application/json;charset=utf-8';
export function sendRequest(api = {}, params = {}) {
  const { type, url } = api;
  const method = type;
  const reqTime = new Date().getTime();
  console.log(`${reqTime} : ${api.url} : req : `, params);
  const baseParams = {
    t: reqTime,
  };
  Object.assign(params, baseParams);
  return Promise.resolve().then(() => {
    if (!method || !url) {
      throw new Error('API信息缺失');
    }
    const tstr = `?t=${reqTime}`;
    const token = storage.local.get('token') || '';
    const axiosConfig = {
      method,
      url: `${url.includes('http') ? '' : config.API_URI}/${url}${method.toLowerCase() !== 'get' ? tstr : ''}`,
      headers: {
        'content-type': contentType,
        token,
      },
      withCredentials: true,
      timeout: 20000,
    };
    if (method.toLowerCase() === 'get') {
      axiosConfig.params = params || {};
      // if (api.nocache) {
      axiosConfig.params.t = reqTime;
      // }
    } else {
      axiosConfig.data = params || {};
    }
    // console.log(axiosConfig);
    return axios(axiosConfig).then((res) => {
      console.log(`${reqTime} : ${api.url} : res : `, res);
      if (res.headers && res.headers['new-token']) {
        storage.local.set('token', res.headers['new-token'] || '');
      }
      if (res.data.success) {
        return res.data.data;
      }
      if (res.data.code === '1001') {
        console.error(`${reqTime} : ${api.url} : error : `, res.data.code);
        storage.local.set('token', '');
        router.push({ path: '/login' });
        throw new Error('请先登录');
      } else if (res.data.code === '1002') {
        console.error(`${reqTime} : ${api.url} : error : `, res.data.code);
        storage.local.set('token', '');
        router.push({ path: '/login' });
        throw new Error('发现您长时间未登录，请重新登录');
      } else {
        const error = new Error(`${res.data.message}`);
        console.error(`${reqTime} : ${api.url} : error : `, error);
        throw error;
      }
    }).catch((e) => {
      console.error(`${reqTime} : ${api.url} : error : `, e.message);
      // if (e.response && e.response.status === '401') {
      //   storage.local.set('token', '');
      //   router.push({ path: '/login' });
      //   throw new Error('登录超时，请重新登录');
      // }
      throw e;
    });
  });
}

export function upload(api, params) {
  const reqTime = new Date().getTime();
  return axios.post(`${config.API_URI}/${api.url}`, params,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        token: storage.local.get('token'),
      },
    }).then((res) => {
    console.log(`${reqTime} : ${api.url} : res : `, res);
    if (res.headers && res.headers['new-token']) {
      storage.local.set('token', res.headers['new-token']);
    }
    if (res.data.success) {
      return res.data.data;
    }
    if (['10001', '1001'].includes(res.data.code)) {
      console.error(`${reqTime} : ${api.url} : error : `, res.data.code);
      storage.local.set('token', '');
      router.push({ path: '/login' });
      throw new Error(res.data.code);
    } else {
      const error = new Error(`${res.data.message}`);
      console.error(`${reqTime} : ${api.url} : error : `, error);
      throw error;
    }
  }).catch((e) => {
    console.error(`${reqTime} : ${api.url} : error : `, e);
    throw e;
  });
}
